import { render, staticRenderFns } from "./textfield.vue?vue&type=template&id=a435842e&scoped=true&"
import script from "./textfield.vue?vue&type=script&lang=js&"
export * from "./textfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a435842e",
  null
  
)

export default component.exports